import { render, staticRenderFns } from "./AiJobs.vue?vue&type=template&id=b0c56c14&scoped=true&"
import script from "./AiJobs.vue?vue&type=script&lang=js&"
export * from "./AiJobs.vue?vue&type=script&lang=js&"
import style0 from "./importer.css?vue&type=style&index=0&id=b0c56c14&scoped=true&lang=css&"
import style1 from "./AiJobs.vue?vue&type=style&index=1&id=b0c56c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c56c14",
  null
  
)

export default component.exports